import error from './errors';
import validate from './validates';
import menu from './menu';
import vuetify from './vuetify';

export default {
  error,
  validate,
  menu,
  $vuetify: vuetify,
  app: {
    title: 'BATS',
    account: 'My account',
    settings: 'Settings',
    logOut: 'Logout'
  },
  login: {
    title: 'Login',
    title_nit: 'Login as administrator',
    user: 'Username',
    password: 'Password',
    nit: 'NIT',
    rememberMe: 'Remember me',
    forgotPass: 'Forgot password?',
    login: 'Login',
    noAccount: 'Dont have an account?',
    signUp: 'Signup here'
  },
  common: {
    required_fields: 'Fields are required',
    add: 'Add',
    required: 'Required',
    cancel: 'Cancel',
    save: 'Save',
    rowsPage: 'Rows per page',
    updateList: 'Update list',
    filters: 'Filters/Search',
    of: 'of',
    active: 'Active',
    observation: 'Observation',
    firm: 'Sign',
    approve: 'Approve and sign',
    edit: 'Edit',
    status: 'State',
    actions: 'Actions',
    close: 'Close',
    general_information: 'General Information',
    contact_information: 'Contact Information',
    other_information: 'Others'
  },
  entity: {
    title: 'Entities',
    add: 'Add new entity',
    crud: {
      edit: 'Edit',
      code: 'Code',
      name: 'Name',
      acronym: 'Acronym',
      description: 'Description',
      status: 'Status',
      addEnt: 'Add entity',
      editEnt: 'Edit entity',
      address: 'Address',
      email: 'Email address',
      phones: 'Telephone number(s)',
      web: 'Official web page of institution',
      user_data: 'Recoverable user data'
    }
  },
  account: {
    title: 'Accounts',
    add: 'Add new account',
    select: 'Choose an entity to see its accounts',
    crud: {
      edit: 'Edit',
      accountNumber: 'Account number',
      status: 'Status',
      entity: 'Entity',
      addAc: 'Add account',
      editAc: 'Edit account'
    }
  },
  user: {
    title: 'Users',
    add: 'Add new user',
    crud: {
      edit: 'Edit',
      user: 'User',
      userData: 'User info',
      entity: 'Entity',
      role: 'Role',
      status: 'Status',
      addUser: 'Add user',
      editUser: 'Edit user',
      fullname: 'Fullname',
      email: 'Email'
    }
  },
  rol: {
    title: 'Roles',
    add: 'Add new rol',
    crud: {
      name: 'Name',
      description: 'Description',
      tipo: 'Type',
      path: 'Path',
      editRol: 'Edit Rol',
      addRol: 'Add Rol'
    }
  },
  parametro: {
    title: 'Parameters',
    add: 'Add new parameter',
    preferencias: 'Preferences',
    crud: {
      name: 'Name',
      value: 'Value',
      label: 'Label',
      description: 'Description',
      editParametro: 'Edit parameter',
      addParametro: 'Add paremeter'
    }
  },
  module: {
    title: 'Modules',
    add: 'Add new',
    crud: {
      edit: 'Edit',
      module: 'Module',
      label: 'Title',
      path: 'Path',
      icon: 'Icon',
      order: 'Order',
      status: 'State',
      visible: 'Visible',
      is_visible: 'Is visible',
      submodule: 'Sub module',
      section: 'Section',
      addModule: 'Add module',
      editModule: 'Edit module',
      permissions: 'Permissions'
    }
  },
  log: {
    title: 'Logs',
    crud: {
      nivel: 'Level',
      tipo: 'Type',
      mensaje: 'Message',
      referencia: 'Reference',
      ip: 'IP',
      path: 'Path',
      fecha: 'Date created',
      usuario: 'User'
    }
  },
  servicioIop: {
    title: 'Interoperability',
    add: 'Add new service',
    crud: {
      codigo: 'Code',
      metodo: 'Method',
      descripcion: 'Description',
      entidad: 'Entity',
      url: 'Url',
      token: 'Token',
      tipo: 'Type',
      estado: 'State',
      editServicio: 'Edit IOP service',
      addServicio: 'Add IOP service'
    }
  },
  canales: {
    title: 'Communication channels',
    add: 'Add new channel',
    crud: {
      mensaje_bienvenida: 'Mensaje de bienvenida / respuesta inmediata',
      edit: 'Edit',
      code: 'Code',
      clasificacion: 'Classification',
      usuario: 'User',
      description: 'Description',
      status: 'Status',
      agregarRegistro: 'Add communication channel',
      editarRegistro: 'Edit communication channel',
      ruta_perfil: 'Profile path',
      twitter_id: 'Twitter ID',
      servidor: 'E-mail server',
      sesion_id: 'Session ID',
      sesion_url: 'Session URL',
      servidor_smtp: 'SMTP Server',
      puerto_smtp: 'SMTP Port'
    }
  },
  chat: {
    title: 'Conversations',
    verificacion: 'Data verification',
    ver_persona: 'Personal information'
  },
  tramites: {
    title: 'Procedures',
    add: 'Add new procedure',
    label: 'Procedure',
    quick_response: 'Quick response',
    crud: {
      nombre_tramite: 'Procedure name',
      entidad: 'Entity'
    }
  },
  faqs: {
    title: 'Frequently asked questions',
    add: 'Add question',
    list: 'List of frequently asked questions'
  },
  operadores: {
    crud: {
      tipo: 'Type',
      persona: 'Person / Channel',
      descripcion: 'Description'
    },
    historial: 'History',
    pendientes: 'Pending',
    conversacion: 'Conversation',
    ingresar: 'Enter the conversation',
    cubiculo: {
      iniciar: 'Select an information point',
      cambiar: 'Change to another information point',
      requerido: 'You must select an information point',
      salir: 'Quit the current information point'
    },
    caso: {
      resumen: 'Summation'
    }
  },
  puntos_atencion: {
    titulo: 'Information points',
    nodata: 'No Information points',
    crud: {
      identificador: 'Identifier',
      entidad: 'Entity'
    }
  },
  caso: {
    derivar: 'Derive case',
    cerrar: 'Close case',
    adjuntar: 'Attach case',
    canal_principal: 'This is the main channel',
    crud: {
      tipo: 'Case type',
      nombre_completo: 'Name',
      nro_documento: 'ID',
      telefono: 'Telephone number',
      movil: 'Cellphone number',
      descripcion: 'Description',
      identificador: 'Information point',
      ultimo_mensaje: 'Last message',
      ultima_actualizacion: 'Last update'
    }
  },
  persona: {
    agregar_dato: 'Add new field',
    remover_dato: 'Remove this field'
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/en/messages.js